package floris.graphics.landing.pages.projects

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.constants.Res
import floris.graphics.core.navigation.Navigation
import floris.graphics.core.utils.reloadAllVideos
import com.materialdesignsystem.components.CheckeredListSection
import com.materialdesignsystem.components.Spacer
import com.materialdesignsystem.components.widgets.DsMaterialSymbols
import com.materialdesignsystem.components.widgets.DsVideo
import com.materialdesignsystem.components.widgets.FilledTonalButton
import com.materialdesignsystem.constants.Attributes
import com.materialdesignsystem.constants.Constants.HEADER_HEIGHT
import floris.graphics.core.Constants
import com.materialdesignsystem.toColorScheme
import floris.graphics.landing.components.layouts.PageLayout
import floris.graphics.landing.pages.projects.components.ContributorAndTechstackInfo
import floris.graphics.landing.pages.projects.components.ProjectNavigator
import floris.graphics.models.domain.models.project.ProjectDetail
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Iframe
import org.jetbrains.compose.web.dom.Text
import kotlin.random.Random

//TODO [TicketNumber]: show an error page when an item cannot be found ---> 404

@Page("/project")
@Composable
fun ProjectPage() {
    val ctx = rememberPageContext()

    val projectId = remember(ctx.route) {
        ctx.route.params[Constants.PROJECT_ID]
    }

    val viewModel = remember(projectId) { ProjectViewModel(projectId) }
    val state by viewModel.state.collectAsState()

    LaunchedEffect(ctx.route, state.project) {
        reloadAllVideos()
    }

    ProjectPageContent(state = state)
}

@Composable
private fun ProjectPageContent(
    state: ProjectContract.State
) {
    DsVideo(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.vh)
            .objectFit(ObjectFit.Cover)
            .pointerEvents(PointerEvents.None)
            .top(0.percent) // Make it work with sticky!
            .position(Position.Sticky),
        videoUrl = state.project?.previewVideoMediaFile?.url?.toString() ?: "",
        poster = state.project?.thumbnailMediaFile?.url?.toString(),
        controls = false,
        autoPlay = true,
        loop = true
    )

    PageLayout(
        modifier = Modifier.zIndex(1),
        title = Res.String.Detail,
        showMenuItems = false,
        footerBackgroundColor = if (state.nextProjectId == null && state.previousProjectId == null) ColorMode.current.toColorScheme.secondaryContainer else ColorMode.current.toColorScheme.background

    ) {
        // TODO [TicketNumber]: show a loading state
        if (state.project != null) {
            ProjectContent(
                project = state.project,
                nextProjectId = state.nextProjectId,
                previousProjectId = state.previousProjectId,
                headerMarginTop = state.headerMarginTop
            )
        }
    }

    ProjectNavigator(
        nextProjectId = state.nextProjectId,
        previousProjectId = state.previousProjectId,
        showProjectNavigators = state.showProjectNavigators
    )
}

@Composable
private fun ProjectContent(
    project: ProjectDetail,
    nextProjectId: String?,
    previousProjectId: String?,
    headerMarginTop: CSSSizeValue<CSSUnit.px>
) {
    val breakpoint = rememberBreakpoint()
    val colorScheme = ColorMode.current.toColorScheme

    Column(
        modifier = Modifier
            .rowGap(if (breakpoint >= Breakpoint.MD) 100.px else 50.px)
            .fillMaxWidth()
            .margin(
                top = 100.vh
                    .minus(HEADER_HEIGHT.px)
                    .minus(if (breakpoint < Breakpoint.SM) 140.px else 100.px)
            )
            .padding(top = if (breakpoint < Breakpoint.SM) 40.px else 70.px)
            .boxShadow(0.px, (-4).px, 4.px, 0.px, colorScheme.primary.toRgb().copyf(alpha = 0.4f))
            .background(colorScheme.background)
            .borderRadius(topLeft = 45.px, topRight = 45.px),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Top
    ) {
        Box(
            modifier = Modifier
                .maxWidth(Constants.SECTION_WIDTH.px)
                .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent)
                .display(DisplayStyle.Flex)
                .justifyContent(JustifyContent.SpaceBetween)
                .alignItems(AlignItems.Center)
                .flexWrap(FlexWrap.Wrap)
                .rowGap(80.px)
                .margin(bottom = 80.px, top = headerMarginTop)
        ) {
            Box(
                modifier = Modifier
                    .display(DisplayStyle.Flex)
                    .justifyContent(JustifyContent.SpaceBetween)
                    .alignItems(AlignItems.FlexEnd)
                    .fillMaxWidth()
                    .flexWrap(FlexWrap.Wrap)
                    .rowGap(50.px)
                    .width(if (breakpoint > Breakpoint.LG) 28.percent else 100.percent)
            ) {
                // Project Detail Info
                Column(
                    modifier = Modifier
                        .width(
                            when {
                                breakpoint > Breakpoint.LG -> 100.percent
                                breakpoint <= Breakpoint.SM -> 100.percent
                                else -> 75.percent
                            }
                        )
                ) {
                    SpanText(
                        modifier = Modifier
                            .fontSize(36.px)
                            .lineHeight(46.px)
                            .fontWeight(FontWeight.Bold),
                        text = project.title
                    )

                    SpanText(
                        modifier = Modifier
                            .margin(top = 10.px)
                            .fontSize(20.px)
                            .lineHeight(20.px),
                        text = project.subtitle
                    )

                    SpanText(
                        modifier = Modifier
                            .margin(top = 10.px)
                            .fontSize(16.px)
                            .lineHeight(22.px),
                        text = project.content
                    )
                }

                ContributorAndTechstackInfo(
                    modifier = Modifier
                        .width(
                            when {
                                breakpoint > Breakpoint.LG -> 100.percent
                                breakpoint <= Breakpoint.SM -> 100.percent
                                else -> 23.percent
                            }
                        ),
                    breakpoint = breakpoint,
                    detail = project
                )
            }

            // Youtube or Vimeo Iframe
            Iframe(
                attrs = Modifier
                    .borderRadius(8.px)
                    .overflow(Overflow.Hidden)
                    .aspectRatio(16, 9)
                    .width(if (breakpoint > Breakpoint.LG) 66.percent else 100.percent)
                    .toAttrs {
                        attr(Attributes.AllowFullscreen, "")
                        attr(Attributes.Src, project.embeddedVideoUrl ?: "")
                    }
            )
        }

        CheckeredListSection(
            modifier = Modifier
                .maxWidth(Constants.SECTION_WIDTH.px)
                .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent),
            items = project.frameMediaFiles,
            calculateRandomGroupSize = { maxItemsInRow, leftovers, currentIndex ->
                when {
                    maxItemsInRow == 1 -> 1 // For Breakpoint.SM, always 1 item per row
                    maxItemsInRow == 2 || leftovers in listOf(2, 4) -> 2 // To avoid ending up with a single item in the last group
                    leftovers == 3 || leftovers > 4 -> (2..3).random(Random(currentIndex + 1))
                    else -> leftovers // When leftovers are 2 or less, just use the remaining items
                }
            }
        ) {
            if (it.mimeType.startsWith("video/")) {
                DsVideo(
                    videoUrl = it.url.toString(),
                    modifier = Modifier
                        .fillMaxSize()
                        .borderRadius(14.px)
                        .objectFit(ObjectFit.Cover)
                )
            } else if (it.mimeType.startsWith("image/")) {
                Image(
                    src = it.url.toString(),
                    modifier = Modifier
                        .fillMaxSize()
                        .aspectRatio(16, 9)
                        .borderRadius(18.px)
                        .overflow(Overflow.Clip)
                        .objectFit(ObjectFit.Cover)
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .visibility(if (previousProjectId == null && nextProjectId == null) Visibility.Hidden else Visibility.Visible)
                .background(ColorMode.current.toColorScheme.secondaryContainer),
            contentAlignment = Alignment.Center
        ) {
            Row(
                modifier = Modifier
                    .maxWidth(Constants.SECTION_WIDTH.px)
                    .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 80.percent else 90.percent)
                    .padding(topBottom = 32.px)
            ) {
                if (previousProjectId != null) {
                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.CenterStart
                    ) {
                        TextButtonIsh(
                            text = Res.String.PreviousShort,
                            href = Navigation.Screen.Project.getProject(previousProjectId),
                            enabled = true,
                            startIcon = {
                                DsMaterialSymbols(icon = "arrow_back")
                            }
                        )
                    }
                }

                if (nextProjectId != null) {
                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.CenterEnd
                    ) {
                        TextButtonIsh(
                            text = Res.String.NextShort,
                            href = Navigation.Screen.Project.getProject(nextProjectId),
                            enabled = true,
                            endIcon = {
                                DsMaterialSymbols(icon = "arrow_forward")
                            }
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun TextButtonIsh(
    text: String,
    href: String,
    enabled: Boolean,
    startIcon: @Composable () -> Unit = {},
    endIcon: @Composable () -> Unit = {}
) {
    A(
        href = href,
        attrs = Modifier
            .textDecorationLine(TextDecorationLine.None)
            .toAttrs()
    ) {
        FilledTonalButton(
            enabled = enabled,
            onClick = {}
        ) {
            startIcon()

            Spacer(Modifier.width(8.px))

            Text(text)

            Spacer(Modifier.width(8.px))

            endIcon()
        }
    }
}
